/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_SECTIONS = gql`
  query GetSections($filter: SectionFilterInput, $options: GetManyOptions) {
    getSections(filter: $filter, options: $options) {
      content {
        id
        name
        alias
        description
        images
        img1
        img2
        isVisible
        regMode
        position
        costumeTypes {
          id
          name
          code
          description
          images
          img1
          img2
          isMandatory
          isVisible
          isSingleFeature
          minDownPayment
          price
          isSingleSection
          costumeFeatures {
            id
            name
            alias
            basePrice
            code
            currency
            desc
            images
            img1
            img2
            isCommon
            isLabel
            isMandatory
            isSingleAttribute
            isVisible
            maxInventory
            featurePosition
            costumeAttributes {
              id
              name
              images
              costumeValues {
                id
                name
                currency
                deadline
                desc
                inventory
                isMandatory
                isLabel
                isVisible
                disclaimer
                topupPrice
                minDownPayment
                position
              }
              desc
              dynaInventory
              isDynamic
              isLabel
              isMandatory
              isSingleVal
              isVisible
            }
          }
          partitions {
            defaultInvites
            sectionID
            sectionSpecificInvites
            specialInvites
          }
          displayName {
            sectionID
            name
          }
        }
      }
    }
  }
`;
